import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCeramics = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.29336 0.707011C8.65939 0.341266 9.23858 0.317687 9.63125 0.637675L9.70742 0.707011L17.2934 8.29295L17.3617 8.36814C17.6822 8.76092 17.6595 9.34182 17.2934 9.70799L9.70742 17.2939L9.63125 17.3613C9.26461 17.6605 8.73519 17.6605 8.36855 17.3613L8.29336 17.2939L0.706445 9.70799L0.638085 9.63084C0.339356 9.26421 0.33905 8.73461 0.638085 8.36814L0.706445 8.29295L8.29336 0.707011ZM8.99941 16.5859L10.0004 15.5849V12H4.41348L8.99941 16.5859ZM11.0004 14.5849L13.5863 12H11.0004V14.5849ZM1.41348 8.99998L3.41348 11H6.00039V6.99998H3.41445L1.41348 8.99998ZM7.00039 11H14.5863L16.5863 8.99998L14.5863 6.99998H7.00039V11ZM4.41445 5.99998H10.0004V2.41404L9.00039 1.41404L4.41445 5.99998ZM11.0004 5.99998H13.5863L11.0004 3.41404V5.99998Z",
		fill: "black"
	})
});
export default SvgCeramics;
